// extracted by mini-css-extract-plugin
module.exports = {"container":"InvestorEventItem_container__1z-3f","title":"InvestorEventItem_title__3GN1_","time":"InvestorEventItem_time__28i-n","buttons":"InvestorEventItem_buttons__16COC"};